export const fmtValue = (v: unknown, digits = 3) =>
    typeof v === "number" ? v.toFixed(digits) : (v ?? "-");
